import * as Sentry from '@sentry/angular';

import { UserType } from '@shared/enums/user-type';
import { AppVersion } from '@shared/interfaces/app-version';
import { TenantData } from '@shared/interfaces/tenant-data';
import { UserData } from '@shared/interfaces/user-data';

export function setSentryUserContext(user: UserData): void {
  Sentry.setUser({
    id: user.id,
    username: user.name,
    type: UserType[user.userType].toLowerCase(),
    email: user.email,
    phone: user.phone,
    companyId: user.companyId,
  });
}

export function setSentryTenantContext(tenant: TenantData): void {
  Sentry.setUser({
    tenantId: tenant.tenantId,
    tenantName: tenant.name,
  });

  Sentry.setContext('tenant', {
    tenantId: tenant.tenantId,
    tenantName: tenant.name,
    url: tenant.tenantUrl,
    apiUrl: tenant.tenantApiUrl,
    federatedIssuer: tenant.federatedIssuer,
    enterpriseClusterEnabled: tenant.enterpriseClusterEnabled,
  });
}

export function setSentryReleaseTag(version: AppVersion): void {
  if (version?.version_number) {
    Sentry.setTag('release', version.version_number);
  }
}
